<template>
  <modal name="modal-edit-timesheet-2" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>EDIT TIMESHEET</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <div class="general-info row">
      <div class="col-6"><i class="fa fa-tasks"></i>&nbsp;Job: {{ job_name }}</div>
      <div class="col-6"><i class="fa fa-building"></i>&nbsp;Client: {{ client_name }}</div>
    </div>
    <br/>
    <form method="post" @submit.prevent="doSave">
      <div class="row">
        <div class="form-group col">
          <label>Session Date <span class="text-danger">*</span></label>
          <datetime-picker name="session_date" :config="dateOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('session_date')}"
                           v-validate.disable="{ required: true }"
                           v-model="session_date"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('session_date') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label>Start Time <span class="text-danger">*</span></label>
          <datetime-picker name="start_time" :config="timeOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('start_time')}"
                           v-validate.disable="{ required: true }"
                           v-model="start_time"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('start_time') }}</div>
        </div>
        <div class="form-group col">
          <label>End Time <span class="text-danger">*</span></label>
          <datetime-picker name="end_time" :config="timeOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('end_time')}"
                           v-validate.disable="{ required: true }"
                           v-model="end_time"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('end_time') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="break">Break Duration (minutes) <span class="text-danger">*</span></label>
          <input type="text" name="name" id="break"
                 :class="{'form-control': true, 'is-invalid': errors.has('break')}"
                 v-validate.disable="{ required: true }"
                 v-model="break_in_minutes">
          <div class="invalid-feedback">{{ errors.first('break') }}</div>
        </div>
        <div class="form-group col">
          <label for="duration">Duration <span class="text-danger">*</span></label>
          <input type="text" name="name" id="duration" readonly="readonly"
                 :class="{'form-control': true, 'is-invalid': errors.has('duration')}"
                 v-validate.disable="{ required: true }"
                 v-model="duration">
          <div class="invalid-feedback">{{ errors.first('duration') }}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="description">Description <span class="text-danger">*</span></label>
        <textarea id="description" type="text" class="form-control" rows="6" placeholder="Descrpition"
                  :class="{'form-control': true, 'is-invalid': errors.has('description')}"
                  v-validate.disable="{ required: true }"
                  v-model="description"></textarea>
        <div class="invalid-feedback">{{ errors.first('description') }}</div>
      </div>
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Save Changes</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import dayjs from 'dayjs'
  import ServiceTimesheet from '@/services/timesheet'
  import DatetimePicker from 'vue-bootstrap-datetimepicker'

  export default {
    components: {
      BeatLoader,
      DatetimePicker
    },
    data () {
      return this.initialState()
    },
    props: ['value', 'timesheet', 'client_name', 'job_name'],
    computed: {
      duration: function(){
        let start_time = dayjs('2020-01-01 ' + this.start_time);
        let end_time = dayjs('2020-01-01 ' + this.end_time);
        let d = (end_time.diff(start_time, "minute", 2) - this.break_in_minutes)/60.0;
        return d.toFixed(2);
      }
    },
    watch: {
      timesheet: 'init',
      value ( newVal ) {
        if ( newVal ) {
          this.$modal.show('modal-edit-timesheet-2', {});
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          session_date: '',
          start_time: '',
          end_time: '',
          break_in_minutes: 0,
          description: '',
          dateOption: {
            format: 'DD/MM/YYYY',
            useCurrent: true,
          },
          timeOption: {
            format: 'HH:mm',
            useCurrent: true,
          }
        }
      },
      init () {
        let self = this;
        Object.assign(this.$data, this.initialState());
        if ( !self.timesheet ) {
          return;
        }
        self.session_date = dayjs(self.timesheet.session_date).format('DD/MM/YYYY');
        self.start_time = self.timesheet.start_time;
        self.end_time = self.timesheet.end_time;
        self.break_in_minutes = self.timesheet.break;
        self.description = self.timesheet.description;
      },
      closeModal () {
        this.$modal.hide('modal-edit-timesheet-2');
      },
      doSave ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        let postData = {};

        postData.session_date = self.session_date;

        if ( self.start_time != self.timesheet.start_time )
          postData.start_time = self.start_time;

        if ( self.end_time != self.timesheet.end_time )
          postData.end_time = self.end_time;

        if ( self.break_in_minutes != self.timesheet.break )
          postData.break = self.break_in_minutes;

        if ( self.description != self.timesheet.description )
          postData.description = self.description;

        self.state = 'saving';
        ServiceTimesheet.save(self.timesheet.id, postData, timesheet => {
          self.state = '';
          self.$notify({
            type: 'success',
            text: 'Timesheet updated successfully.'
          });
          self.$emit('timesheet-saved', timesheet);
          Object.assign(this.$data, this.initialState());
          self.closeModal();
        }, () => {
          self.state = '';
        });
      }
    }
  }
</script>
